
import { getAuthHookFactory } from "../../../../global/paywall/useAuth";
import { AuthStepsEnum, SiteLinks, CustomerAccessData } from "../../../../global/paywall/paywallInterfaces";
import { PremiumPaywallDesktopSigninEmail } from "./signin/premiumPaywallDesktopSigninEmail"
import { PremiumPaywallDesktopSigninPassword } from "./signin/premiumPaywallDesktopSigninPassword";
import PremiumPaywallCheckoutPlans from "./premiumPaywallPlans";
import { PremiumPaywallState } from "./premiumPaywallDesktop";
import { PremiumPaywallDesktopSigninFinish } from "./signin/premiumPaywallDesktopSigninFinish";




interface PremiumPaywallDesktopSigninProps {
  emailOrPhone: string
  password: string
  agreesTerms: boolean
  setEmailOrPhone: (emailOrPhone: string) => void
  setPassword: (password: string) => void
  setAgreesTerms: (agreesTerms: boolean) => void
  setMode: (state: PremiumPaywallState) => void
  setIsRedirecting: (isRedirect: boolean) => void
  isNewspaper?: boolean;
}

export const PremiumPaywallDesktopSignin = (props: PremiumPaywallDesktopSigninProps) => {
  const { emailOrPhone, setEmailOrPhone, password, setPassword, setMode, agreesTerms, isNewspaper, setIsRedirecting } = props
  const {
    authError,
    step,
    proceedToEmailStep,
    loginWithGoogle,
    loginWithApple,
    thirdPartyLogin,
    sendEmailOrPhoneForLogin,
    submitPassword,
    resetAuth,
    setAuthError,
    setSignInType,
    signInType,
    user
  } = getAuthHookFactory("login")();


  const sendMail = () => {
    sendEmailOrPhoneForLogin(emailOrPhone, agreesTerms)
  }

  const sendPassword = () => {
    submitPassword(password)
  }

  const onReset = () => {
    resetAuth()
  }

  const onThirdPartyLogin = (isNewCustomer: boolean) => {
    thirdPartyLogin(isNewCustomer)
  }

  switch (step) {
    case AuthStepsEnum.PLANS:
      return (
        <PremiumPaywallCheckoutPlans
          proceedToEmailStep={proceedToEmailStep}
          setMode={setMode}
        />)
    case AuthStepsEnum.EMAIL:
      return (
        <PremiumPaywallDesktopSigninEmail
          emailOrPhone={emailOrPhone}
          setEmailOrPhone={setEmailOrPhone}
          setMode={setMode}
          loginWithGoogle={loginWithGoogle}
          loginWithApple={loginWithApple}
          sendMail={sendMail}
          authError={authError}
          isNewspaper={isNewspaper}
          setAuthError={setAuthError}
          setSignInType={setSignInType}
          signInType={signInType}
        />
      )

    case AuthStepsEnum.PASSWORD:
      return (
        <PremiumPaywallDesktopSigninPassword
          emailOrPhone={emailOrPhone}
          password={password}
          setPassword={setPassword}
          onContinue={sendPassword}
          onBack={onReset}
          sendMail={sendMail}
          authError={authError}
          setEmailOrPhone={setEmailOrPhone}
          signInType={signInType}
        />
      )

    case AuthStepsEnum.CONFIRM_TERMS:
      // if its sign in, we dont need to confirm terms
      onThirdPartyLogin(false)
      return null

    case AuthStepsEnum.FINISH:
      return <PremiumPaywallDesktopSigninFinish user={user} setIsRedirecting={setIsRedirecting} />
    default:
      return null
  }
};
